/** @jsx jsx */

import { Fragment as _, memo, useContext } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { interactionContext as InteractionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from 'factories/block';
import TopicPortalContainer from './TopicPortalContainer';
import shouldUpdate from 'services/shouldUpdate';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { imgPlaceholders } from 'components/lib/Image';
import Topic_Portal_Background from 'assets/Topic Portal Background.svg';
import longRectangle from 'assets/Long Rectangle.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [topicPortal, txt] = children;

    if (!includeAdditionalTextField) {
      return topicPortal;
    }

    return (
      <_>
        {topicPortal}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },

  TopicPortalContainer,
  TopicPortalMedia: ({ children, ...props }) => {
    return children;
  },
  Media,

  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: isAdditionalMedia
            ? longRectangle
            : Topic_Portal_Background || imgPlaceholders[1],
          //
          editWrapperType: 1,
          editWrapperSize: '80%',
          editWrapperUseIcon: false,
          canUpdateContainerHeight: false,
        }}
      />
    );
  },

  Video,
  Audio,
  SVG,
  PDF,
  OpenPDF,
  Embed,
  Transcript: ({ children }) => children,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: continueBtn,
};

const TopicPortalDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default TopicPortalDisplay;
